module.exports = "<p>comprobante works!</p>\n"